import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "tw-flex tw-items-center tw-gap-2 tw-w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputField = _resolveComponent("InputField")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_InputField, {
      "onUpdate:modelValue": _ctx.handleInput,
      modelValue: _ctx.modelValue,
      class: "tw-flex-1",
      placeholder: _ctx.placeholder,
      largeWidth: true,
      enableCancel: true
    }, null, 8, ["onUpdate:modelValue", "modelValue", "placeholder"]),
    (_ctx.modelValue && _ctx.modelValue.length > 0)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clearInput && _ctx.clearInput(...args))),
          class: "tw-inline-flex tw-h-10 tw-w-10 tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white/60 tw-backdrop-blur tw-text-slate-700 hover:tw-bg-white",
          type: "button",
          "aria-label": "Clear"
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: "xmark",
            class: "tw-h-4 tw-w-4"
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}